module.exports = __webpack_public_path__ + "static/media/qrcode.af217413.svg";